import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  CheckSquare,
  Users,
  Clock,
  Calendar,
  Settings,
  Bell,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useAuthStore } from '@/stores/authStore'

interface NavItem {
  title: string
  href: string
  icon: React.ElementType
  supervisorOnly?: boolean
}

const navItems: NavItem[] = [
  {
    title: 'Dashboard',
    href: '/',
    icon: LayoutDashboard,
  },
  {
    title: 'Tasks',
    href: '/tasks',
    icon: CheckSquare,
  },
  {
    title: 'Time Log',
    href: '/time',
    icon: Clock,
  },
  {
    title: 'Clients',
    href: '/clients',
    icon: Users,
    supervisorOnly: true,
  },
  {
    title: 'Calendar',
    href: '/calendar',
    icon: Calendar,
  },
  {
    title: 'Settings',
    href: '/settings',
    icon: Settings,
  },
  {
    title: 'Notifications',
    href: '/settings/notifications',
    icon: Bell,
  },
]

export function Navigation() {
  const { user } = useAuthStore()
  const isSupervisor = user?.role === 'supervisor'

  const filteredItems = navItems.filter(
    (item) => !item.supervisorOnly || isSupervisor
  )

  return (
    <ScrollArea className="h-full py-4">
      <nav className="space-y-1 px-3">
        {filteredItems.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary/10 text-primary border-l-2 border-primary'
                  : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
              )
            }
          >
            <item.icon className={cn('h-4 w-4')} />
            {item.title}
          </NavLink>
        ))}
      </nav>
    </ScrollArea>
  )
}
